import { render, staticRenderFns } from "./Advisor.vue?vue&type=template&id=7a6f1bd2&"
import script from "./Advisor.vue?vue&type=script&lang=js&"
export * from "./Advisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a6f1bd2')) {
      api.createRecord('7a6f1bd2', component.options)
    } else {
      api.reload('7a6f1bd2', component.options)
    }
    module.hot.accept("./Advisor.vue?vue&type=template&id=7a6f1bd2&", function () {
      api.rerender('7a6f1bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/HomeVantage/Summaries/Tabs/Advisor.vue"
export default component.exports